// extracted by mini-css-extract-plugin
export default {"800":"(min-width: 800px)","root":"w1pIHoxXexIuwOD_2UxW","card":"FY5K24GCFU0_CB47hLQ5"};